export default __webpack_public_path__ + "static/media/select-studio-ingame.48a4d022.png";